{
  "about.blocks": "प्रशमितानि सर्वरः",
  "about.contact": "सम्पर्कः:",
  "about.disclaimer": "मास्तोडनस्ति निश्शुल्को विवृत्तस्तन्त्रांशः, मास्तोडन् gGmbH इत्यस्य च व्यापारमुद्रा।",
  "about.domain_blocks.no_reason_available": "कारणं न लभ्यते",
  "about.domain_blocks.preamble": "मास्तोडन्सामान्यतया फेडिभर्सि अन्यस्मात्सर्वरादुपयोक्तृभ्यस्सामग्रीं द्रष्टुम्, तैस्संवादं कर्तुञ्च शक्नोति । एतानि वर्जनानि अस्मिन्सर्वरि कृतास्सन्ति।",
  "about.domain_blocks.silenced.explanation": "सामान्यतया अस्मात्सर्वरात्प्रोफाइल्सामग्रीञ्च न पश्यसि, यावत्स्पष्टतया तन्न पश्यसि अथवा अनुसरणं कृत्वा तस्मिन्विकल्पं न करोति ।",
  "about.domain_blocks.silenced.title": "निबद्धम्",
  "about.domain_blocks.suspended.explanation": "अस्मात्सर्वरः कोऽपि दत्तांशस्संसाधितः, संगृहीतो वा आदानप्रदानो वा न भविष्यति, येन अस्मात्सर्वरः उपयोक्तृभिः किमपि अन्तरक्रिया वा सञ्चारो वा असम्भवति।",
  "about.domain_blocks.suspended.title": "प्रलम्बितः",
  "about.not_available": "अस्मिन्सर्वरि अस्यास्सूचनायाः उपलभ्यो न कृतः।",
  "about.powered_by": "अकेन्द्रीयितसामाजिकजालकर्म {mastodon} द्वारा आधारितम्",
  "about.rules": "सर्वरो नियमाः",
  "account.add_or_remove_from_list": "युज्यतां / नश्यतां सूच्याः",
  "account.badges.bot": "यन्त्रम्",
  "account.badges.group": "समूहः",
  "account.block": "अवरुध्यताम् @{name}",
  "account.block_domain": "अवरुध्यतां प्रदेशः {domain}",
  "account.blocked": "अवरुद्धम्",
  "account.cancel_follow_request": "अनुसरणयाचनामपनय",
  "account.direct": "गोपनीयरूपेण उल्लेखित-@{name}",
  "account.disable_notifications": "यदा @{name} स्थापयति तदा माम्मा ज्ञापय",
  "account.edit_profile": "सम्पाद्यताम्",
  "account.enable_notifications": "यदा @{name} स्थापयति तदा मां ज्ञापय",
  "account.endorse": "व्यक्तिगतविवरणे वैशिष्ट्यम्",
  "account.follow": "अनुस्रियताम्",
  "account.followers": "अनुसर्तारः",
  "account.followers.empty": "नाऽनुसर्तारो वर्तन्ते",
  "account.following": "अनुसरति",
  "account.follows.empty": "न कोऽप्यनुसृतो वर्तते",
  "account.go_to_profile": "प्रोफायिलं गच्छ",
  "account.hide_reblogs": "@{name} मित्रस्य प्रकाशनानि छिद्यन्ताम्",
  "account.in_memoriam": "स्मृत्याम्",
  "account.joined_short": "युक्तम्",
  "account.languages": "निवेशितभाषां परिवर्तय",
  "account.link_verified_on": "अन्तर्जालस्थानस्यास्य स्वामित्वं परीक्षितमासीत् {date} दिने",
  "account.locked_info": "एतस्या लेखायाः गुह्यता \"निषिद्ध\"इति वर्तते । स्वामी स्वयञ्चिनोति कोऽनुसर्ता भवितुमर्हतीति ।",
  "account.media": "सामग्री",
  "account.mention": "उल्लिख्यताम् @{name}",
  "account.moved_to": "{name} द्वारा सूचितं यत्तस्य नव एकाउण्ट् सद्यः अस्ति :",
  "account.mute": "निःशब्दम् @{name}",
  "account.muted": "निःशब्दम्",
  "account.open_original_page": "मूलपृष्ठमुट्घाटय",
  "account.posts": "पत्राणि",
  "account.report": "आविद्यताम् @{name}",
  "account.requested_follow": "{name} त्वामनुसर्तुमयाचीत्",
  "account.share": "@{name} मित्रस्य विवरणं विभाज्यताम्",
  "account.show_reblogs": "@{name} मित्रस्य प्रकाशनानि दृश्यन्ताम्",
  "account.unblock": "निषेधता नश्यताम् @{name}",
  "account.unblock_domain": "प्रदेशनिषेधता नश्यताम् {domain}",
  "account.unblock_short": "अनवरुन्धि",
  "account.unendorse": "व्यक्तिगतविवरणे मा प्रकाश्यताम्",
  "account.unfollow": "नश्यतामनुसरणम्",
  "account.unmute": "सशब्दम् @{name}",
  "account.unmute_short": "अनमूकीकुरु",
  "account_note.placeholder": "टीकायोजनार्थं नुद्यताम्",
  "admin.dashboard.daily_retention": "पञ्जीकरणस्यानन्तरमुपयोक्तृधारणदरो दिनेन",
  "admin.dashboard.monthly_retention": "पञ्जीकरणस्यानन्तरमुपयोक्तृधारणदरो मासेन",
  "admin.dashboard.retention.average": "मध्यत्वम्",
  "admin.dashboard.retention.cohort": "पञ्जीकरणमासः",
  "admin.dashboard.retention.cohort_size": "नवोपभोक्तारः",
  "alert.rate_limited.message": "{retry_time, time, medium}. समयात् पश्चात् प्रयतताम्",
  "alert.rate_limited.title": "सीमितगतिः",
  "alert.unexpected.message": "अनपेक्षितदोषो जातः ।",
  "alert.unexpected.title": "अरे !",
  "announcement.announcement": "उद्घोषणा",
  "attachments_list.unprocessed": "(अप्रकृतम्)",
  "audio.hide": "ध्वनिं प्रच्छादय",
  "boost_modal.combo": "{combo} अत्र स्प्रष्टुं शक्यते, त्यक्तुमेतमन्यस्मिन् समये",
  "bundle_column_error.copy_stacktrace": "त्रुट्यावेदनं प्रतिलिपिङ्कुरु",
  "bundle_column_error.error.body": "अनुरोधितं पृष्ठं प्रतिपादयितुं न शक्यते। अस्माकं कोडि दोषस्य कारणेन, अथवा ब्राउजर् संगततायास्समस्यायाः कारणेन भवितुमर्हति।",
  "bundle_column_error.error.title": "हा हन्त!",
  "bundle_column_error.network.body": "पृष्ठमिदं लोडङ्कर्तुं प्रयतमाने त्रुटिरभवत्। एतत्तव अन्तर्जालसम्पर्कस्य अथवा अस्य सर्वरोऽस्थायिन्यास्समस्यायाः कारणेन भवितुमर्हति।",
  "bundle_column_error.network.title": "अन्तर्जालस्य त्रुटिः",
  "bundle_column_error.retry": "पुनः यतताम्",
  "bundle_column_error.return": "गृहं प्रतिगच्छ",
  "bundle_column_error.routing.body": "अनुरोधितं पृष्ठं न लब्धम्। URL सङ्केतं सम्यगस्तीति कृपया दृढीकुरु।",
  "bundle_column_error.routing.title": "४०४",
  "bundle_modal_error.close": "पिधीयताम्",
  "bundle_modal_error.retry": "पुनः यतताम्",
  "closed_registrations.other_server_instructions": "यतोहि मस्टोडोनक्रेन्द्रीयकृतमस्ति, अन्यास्मिन्सर्वरि एकौण्टं स्रष्टुं शक्नोषि एवञ्च एतेन संयोक्तुं शक्नोषि।",
  "closed_registrations_modal.description": "{domain} मध्ये एकौण्टं करणमधुना न सम्भवति, किन्तु कृपया अवधीयतां यन्मास्टोडोनमुपयोक्तुं {domain} मध्ये एकौण्टं करणं नावश्यकम्।",
  "closed_registrations_modal.find_another_server": "अन्य सर्वरमन्विच्छ",
  "closed_registrations_modal.preamble": "मास्टोडोनस्ति अक्रेन्द्रीयकृतमतः कुहापि एकौण्टं स्रष्टुमर्हसि, अस्मिन्सर्वरि सदस्यैश्च संयोक्तुं शक्नोषि। स्वस्य सर्वरं स्रष्टुमपि शक्नोषि।",
  "closed_registrations_modal.title": "मास्टोडोनि पञ्जीकरणम्",
  "column.about": "विषये",
  "column.blocks": "निषिद्धभोक्तारः",
  "column.bookmarks": "पुटचिह्नानि",
  "column.community": "स्थानीयसमयतालिका",
  "column.direct": "गोपनीयरूपेण उल्लिखितानि",
  "column.directory": "व्यक्तित्वानि दृश्यन्ताम्",
  "column.domain_blocks": "निषिद्धप्रदेशाः",
  "column.follow_requests": "अनुसरणानुरोधाः",
  "column.home": "गृहम्",
  "column.lists": "सूचयः",
  "column.mutes": "निःशब्दाः भोक्तारः",
  "column.notifications": "सूचनाः",
  "column.pins": "कीलितपत्राणि",
  "column.public": "सङ्घीयसमयतालिका",
  "column_back_button.label": "पूर्वम्",
  "column_header.hide_settings": "विन्यासाः छाद्यन्ताम्",
  "column_header.moveLeft_settings": "स्तम्भो वामी क्रियताम्",
  "column_header.moveRight_settings": "स्तम्भो दक्षिणी क्रियताम्",
  "column_header.pin": "कीलयतु",
  "column_header.show_settings": "विन्यासाः दृश्यन्ताम्",
  "column_header.unpin": "कीलनं नाशय",
  "community.column_settings.local_only": "केवलं स्थानीयम्",
  "community.column_settings.media_only": "सामग्री केवलम्",
  "community.column_settings.remote_only": "दर्गमः केवलम्",
  "compose.language.change": "भाषां परिवर्तय",
  "compose.language.search": "भाषाः अन्विच्छ",
  "compose_form.direct_message_warning_learn_more": "अधिकं ज्ञायताम्",
  "compose_form.encryption_warning": "मस्टोडोनि पत्राणि न अन्ततोऽन्तं सङ्कूटितानि। मास्टोडिनि संवेदनशीलसूचनां मा प्रेषय।",
  "compose_form.hashtag_warning": "पत्रमिदमसार्वजनिकान्न कस्मिन्नपि प्रचलितवस्तुषु सूचितमिदं प्रेषणम्। केवलं सार्वजनिकप्रेषराणि प्रचलितवस्तुचिह्नेन अन्वेषयितुं शक्यते।",
  "compose_form.lock_disclaimer": "तव लेखा न प्रवेष्टुमशक्या {locked} । कोऽप्यनुसर्ता ते केवलमनुसर्तृृणां कृते स्थितानि पत्राणि द्रष्टुं शक्नोति ।",
  "compose_form.lock_disclaimer.lock": "अवरुद्धः",
  "compose_form.placeholder": "मनसि ते किमस्ति?",
  "compose_form.poll.duration": "मतदान-समयावधिः",
  "compose_form.poll.switch_to_multiple": "मतदानं परिवर्तयित्वा बहुवैकल्पिकमतदानं क्रियताम्",
  "compose_form.poll.switch_to_single": "मतदानं परिवर्तयित्वा निर्विकल्पमतदानं क्रियताम्",
  "compose_form.spoiler.marked": "प्रच्छान्नाक्षरं विद्यते",
  "compose_form.spoiler.unmarked": "अप्रच्छन्नाक्षरं विद्यते",
  "confirmation_modal.cancel": "नश्यताम्",
  "confirmations.block.confirm": "निषेधः",
  "confirmations.delete.confirm": "मार्जय",
  "confirmations.delete.message": "निश्चयेन पत्रमिदं मार्जितुमिच्छसि?",
  "confirmations.delete_list.confirm": "मार्जय",
  "confirmations.delete_list.message": "सूचिरियं निश्चयेन स्थायित्वेन च मार्जितुमिच्छसि वा?",
  "confirmations.discard_edit_media.confirm": "अपास्य",
  "confirmations.discard_edit_media.message": "माध्यमवर्णनां प्रदर्शनञ्च अरक्षितानि परिवर्तनानि सन्ति, तानि अपासितुमिच्छसि वा?",
  "confirmations.logout.confirm": "बहिर्गम्यताम्",
  "confirmations.logout.message": "निश्चयेनैव बहिर्गमनं वाञ्छितम्?",
  "confirmations.mute.confirm": "निःशब्दम्",
  "confirmations.redraft.confirm": "मार्जय पुनश्च लिख्यताम्",
  "confirmations.unfollow.confirm": "अनुसरणं नश्यताम्",
  "conversation.delete": "वार्तालापं मार्जय",
  "conversation.mark_as_read": "पठितमित्यङ्क्यताम्",
  "conversation.open": "वार्तालापो दृश्यताम्",
  "conversation.with": "{names} जनैः साकम्",
  "copypaste.copied": "प्रतिलिपिंकृतम्",
  "copypaste.copy_to_clipboard": "क्लिप्बोर्दमनुलिपिं कुरु",
  "directory.federated": "सुपरिचितं Fediverse इति स्थानात्",
  "directory.local": "{domain} प्रदेशात्केवलम्",
  "directory.new_arrivals": "नवामगमाः",
  "directory.recently_active": "नातिपूर्वं सक्रियः",
  "disabled_account_banner.account_settings": "एकौण्टः सेटिङ्ग्स्",
  "disabled_account_banner.text": "तव एकौण्ट् {disabledAccount} अधुना निष्कृतमस्ति।",
  "dismissable_banner.community_timeline": "तानि तेषां जनानां नूतनतमानि सार्वजनिकानि पत्राणि सन्ति येषामेकौण्टः {domain} द्वारा होस्त् भवन्ति।",
  "dismissable_banner.dismiss": "अपास्य",
  "embed.instructions": "पत्रमेतत्स्वीयजालस्थाने स्थापयितुमधो लिखितो विध्यादेशो युज्यताम्",
  "embed.preview": "अत्रैवं दृश्यते तत्:",
  "emoji_button.activity": "आचरणम्",
  "emoji_button.clear": "मार्जय",
  "emoji_button.custom": "स्वीयानुकूलम्",
  "emoji_button.flags": "ध्वजाः",
  "emoji_button.food": "भोजनं पेयञ्च",
  "emoji_button.label": "भावचिह्नं युज्यताम्",
  "emoji_button.nature": "प्रकृतिः",
  "emoji_button.not_found": "न भावचिह्नानि (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "वस्तूनि",
  "emoji_button.people": "जनाः",
  "emoji_button.recent": "आधिक्येन प्रयुक्तम्",
  "emoji_button.search": "अन्विष्यताम्...",
  "emoji_button.search_results": "अन्वेषणपरिणामाः",
  "emoji_button.symbols": "चिह्नानि",
  "emoji_button.travel": "यात्रा च स्थानानि",
  "empty_column.account_suspended": "एकौण्ट् निलम्बितः",
  "empty_column.account_timeline": "न पत्रमिह!",
  "empty_column.account_unavailable": "व्यक्तित्वं न प्राप्यते",
  "empty_column.blocks": "नैकोऽप्युपभोक्ता निषिद्धो वर्तते",
  "empty_column.bookmarked_statuses": "नैकमपि पुटचिह्नयुक्तपत्राणि सन्ति । यदा भविष्यति तदत्र दृश्यते ।",
  "empty_column.community": "स्थानीयसमयतालिका रिक्ता । सार्वजनिकत्वेनाऽत्र किमपि लिख्यताम् ।",
  "empty_column.direct": "नैकोऽपि साक्षदुल्लिखितं वर्तते। यदा प्रेष्यते वा प्राप्यतेऽत्र दृश्यते।",
  "empty_column.domain_blocks": "न निषिद्धप्रदेशाः सन्ति ।",
  "empty_column.explore_statuses": "अधुना किमपि न प्रचलति। परे पुनः पश्य!",
  "empty_column.follow_requests": "नाऽनुसरणानुरोधस्ते वर्तते । यदैको प्राप्यतेऽत्र दृश्यते ।",
  "empty_column.followed_tags": "कान्यपि प्रचलितवस्तूनीदानीमपि नान्वसार्षीः। यदा अनुसरसि तदा तानि इह दृश्यन्ते।",
  "empty_column.hashtag": "नाऽस्मिन् प्रचलितवस्तुचिह्ने किमपि ।",
  "empty_column.home": "गृहसमयतालिका रिक्ताऽस्ति । गम्यतां {public} वाऽन्वेषणैः प्रारभ्यतां मेलनं क्रियताञ्च ।",
  "empty_column.list": "न किमपि वर्तते सूच्यामस्याम् । यदा सूच्याः सदस्या नवपत्राणि प्रकटीकुर्वन्ति तदाऽत्राऽऽयान्ति ।",
  "empty_column.mutes": "त्वया अद्यापि नैकोऽप्युपभोक्ता मूकीकृतो वर्तते।",
  "empty_column.notifications": "तव पार्श्वे न अधुना पर्यन्तं किमपि विज्ञापनं वर्तते। यदा अन्या जना त्वया संयोजयन्ति तदा इह पश्यसि।",
  "empty_column.public": "न इह किमपि वर्तते! किञ्चिल्लिख सार्वजनिकरूपेण, उत स्वयमन्यसर्वर्तः उपभोक्तॄननुसर एतत्पूरयितुम्",
  "error.unexpected_crash.explanation": "अस्माकं विद्यादेशे दोषादुत ब्रौसर्सङ्गतिसमस्यायाः पृष्ठमिदं सम्यग्रूपेण न दृश्यते।",
  "error.unexpected_crash.explanation_addons": "पृष्ठमिदं सम्यग्रूपेण न दृश्यते। दोषोऽयं सम्भवतो ब्रौसरेडनुत स्वचलितानुवादोपकरणानां कारणात्।",
  "error.unexpected_crash.next_steps": "पृष्ठं पुनः रेफ्रेशं कर्तुं यतस्व। यदि तत्परेऽपि कार्यं नाकार्षीत्तर्ह्यप्यन्यब्रौसरा उत नेटिवेपा मास्टोडोनुपयोक्तुं शक्नोषि।",
  "error.unexpected_crash.next_steps_addons": "तानि निष्क्रियं कृत्वा पृष्ठं रिफ्रेशं कर्तुं यतस्व। यदि तत्परेऽपि कार्यं नाकार्षीत्तर्ह्यप्यन्यब्रौसरा उत नेटिवेपा मास्टोडोनुपयोक्तुं शक्नोषि।",
  "errors.unexpected_crash.copy_stacktrace": "स्तेक्त्रेसमनुलिपिं कुरु क्लिप्फलकं",
  "errors.unexpected_crash.report_issue": "दोषमावेदय",
  "explore.suggested_follows": "जनाः",
  "explore.trending_links": "वार्ताः",
  "explore.trending_statuses": "पत्राणि",
  "explore.trending_tags": "प्रचलितवस्तूनि",
  "filter_modal.added.context_mismatch_explanation": "यस्मिन्सन्दर्भे त्वया पत्रमिदं प्राप्तं तस्मिनयं फिल्तर्वर्गो न प्रवर्तते। यदि इच्छसि पत्रं फिल्तर्कर्तुमस्मिन्सन्दर्भेऽपि, त्वया फिल्तर्सम्पादयितव्यम्।",
  "filter_modal.added.context_mismatch_title": "सन्दर्भोऽसमः!",
  "filter_modal.added.expired_explanation": "फिल्तर्वर्गोऽयं समाप्तः, तस्य संयोजनाय त्वया समाप्तिदिवसः परिवर्तितव्यः।",
  "filter_modal.added.expired_title": "गतप्राणः फिल्तार्!",
  "filter_modal.added.review_and_configure": "फिल्तर्वर्गमिममवलोकनाय अधिकविन्यासाय च, {settings_link} प्रति याहि।",
  "filter_modal.added.review_and_configure_title": "विन्यासान्फिल्तरं कुरु",
  "filter_modal.added.settings_link": "विन्यासपृष्ठम्",
  "filter_modal.added.short_explanation": "पत्रमिदं निम्नलिखितः फिल्तर्वर्गेन योजितः: {title}।",
  "filter_modal.added.title": "फिल्तर्योजितम्!",
  "filter_modal.select_filter.context_mismatch": "अस्मिन्सन्दर्भे न प्रवर्तते",
  "filter_modal.select_filter.expired": "समाप्तम्",
  "filter_modal.select_filter.prompt_new": "नूतनवर्गः: {name}",
  "filter_modal.select_filter.search": "अन्विच्छ उत सृज",
  "filter_modal.select_filter.subtitle": "वर्तमानवर्गं प्रयोजय उत नूतनं सृज",
  "filter_modal.select_filter.title": "पत्रमिदं फिल्तरं कुरु",
  "filter_modal.title.status": "पत्रं फिल्तरं कुरु",
  "follow_request.authorize": "प्रमाणीकुरु",
  "follow_request.reject": "प्रत्याख्याहि",
  "follow_requests.unlocked_explanation": "यद्यपि ते एकौण्ट् तालयन्त्रेण न बन्धितं, {domain} अधिकारिगणोऽचिचिन्तद्यदेतेभ्य एकौण्ट्भ्योऽनुसरणानुरोधानां समीक्षां स्वहस्तेन चिकीर्षसीति।",
  "followed_tags": "अनुसरितानि प्रचलितवस्तूनि",
  "footer.about": "विषये",
  "footer.directory": "मुखपार्श्वविभागः",
  "footer.get_app": "एप् लभस्व",
  "footer.keyboard_shortcuts": "कीफलकहर्स्वमार्गाः",
  "footer.privacy_policy": "गोपनीयतानीतिः",
  "footer.source_code": "स्रोतविद्यादेशं दर्शय",
  "footer.status": "स्थितिः",
  "generic.saved": "रक्षितम्",
  "getting_started.heading": "आरम्भकरणम्",
  "hashtag.column_header.tag_mode.all": "{additional} च",
  "hashtag.column_header.tag_mode.any": "वा {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} विहाय",
  "hashtag.column_settings.select.no_options_message": "न का अपि सूचनाः प्राप्ताः",
  "hashtag.column_settings.select.placeholder": "प्रचलितवस्तूनि प्रविश",
  "hashtag.column_settings.tag_mode.all": "एतानि सर्वाणि",
  "hashtag.column_settings.tag_mode.any": "किञ्चिदेतेषु",
  "hashtag.column_settings.tag_mode.none": "न किमप्येतेषु",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "प्रचलितवस्तु अनुसर",
  "hashtag.unfollow": "प्रचलितवस्तु अनुसरणं वारय",
  "home.column_settings.show_reblogs": "बुस्त् दर्शय",
  "home.column_settings.show_replies": "उत्तराणि दर्शय",
  "home.hide_announcements": "विज्ञापनानि प्रच्छादय",
  "home.show_announcements": "विज्ञापनानि दर्शय",
  "interaction_modal.on_another_server": "अन्यस्मिन्सर्वरि",
  "interaction_modal.on_this_server": "अस्मिन्सर्वरि",
  "intervals.full.days": "{number, plural, one {# दिनम्} other {# दिनानि}}",
  "intervals.full.hours": "{number, plural, one {# होरा} other {# होराः}}",
  "intervals.full.minutes": "{number, plural, one {# क्षणम्} other {# क्षणानि}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "पत्रं बुस्तं कुरु",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "वर्णनम्",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "पत्रं उद्घाटय",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "होत्की",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "कीलितपत्राणां सूचिमुद्घाटय",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "पत्राय प्रतिवादय",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "नूतनपत्रमारभस्व",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "पिधीयताम्",
  "lightbox.next": "परः",
  "lightbox.previous": "पूर्वः",
  "limited_account_hint.action": "प्रोफैलं दर्शय कथञ्चित्",
  "limited_account_hint.title": "{domain} इत्यस्य प्रशासकैरयं प्रोफैल्प्रच्छन्नः।",
  "lists.delete": "सूचिं मार्जय",
  "lists.edit": "सूचिं सम्पादय",
  "lists.replies_policy.followed": "कोऽप्यनुसारितोपभोक्ता",
  "lists.replies_policy.list": "सूचेस्सदस्याः",
  "lists.replies_policy.none": "न कोऽपि",
  "load_pending": "{count, plural, one {# नूतनवस्तु} other {# नूतनवस्तूनि}}",
  "moved_to_account_banner.text": "तव एकौण्ट् {disabledAccount} अधुना निष्कृतो यतोहि {movedToAccount} अस्मिन्त्वमसार्षीः।",
  "navigation_bar.about": "विषये",
  "navigation_bar.blocks": "निषिद्धभोक्तारः",
  "navigation_bar.bookmarks": "पुटचिह्नानि",
  "navigation_bar.direct": "गोपनीयरूपेण उल्लिखितानि",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.filters": "मूकीकृतानि पदानि",
  "navigation_bar.follow_requests": "अनुसरणानुरोधाः",
  "navigation_bar.followed_tags": "अनुसरितानि प्रचलितवस्तूनि",
  "navigation_bar.follows_and_followers": "याननुसरति अनुसारिणश्च",
  "navigation_bar.lists": "सूचयः",
  "navigation_bar.logout": "निष्क्रमणं कुरु",
  "navigation_bar.mutes": "निःशब्दा भोक्तारः",
  "navigation_bar.preferences": "अधिकरुचयः",
  "navigation_bar.search": "अन्विच्छ",
  "not_signed_in_indicator.not_signed_in": "उपायमिमं लब्धुं सम्प्रवेश आवश्यकः।",
  "notification.admin.report": "{name} {target} प्रतिवेदयञ्चकार",
  "notification.admin.sign_up": "{name} संविवेश",
  "notification.follow": "{name} त्वामनुससार",
  "notification.follow_request": "{name} त्वामनुसर्तुमयाचीत्",
  "notification.own_poll": "तव निर्वाचनं समाप्तम्",
  "notification.reblog": "{name} तव पत्रं बुस्तिमिति अकार्षीत्",
  "notification.status": "{name} अधुना अस्थापयिष्ट",
  "notification.update": "{name} पत्रमेकं समपादयिष्ट",
  "notifications.clear": "विज्ञापनानि मार्जय",
  "notifications.clear_confirmation": "तव सर्वाणि विज्ञापनानि सर्वकालाय मार्जयितुमिच्छसि वा?",
  "notifications.column_settings.admin.report": "नूतनावेदनानि",
  "notifications.column_settings.admin.sign_up": "नूतनपञ्जीकरणम्:",
  "notifications.column_settings.alert": "देस्क्टप्विज्ञापनानि",
  "notifications.column_settings.follow": "नूतनानुसारिणः:",
  "notifications.column_settings.follow_request": "नूतनानुसरणानुरोधाः:",
  "notifications.column_settings.mention": "उल्लिखितानि :",
  "notifications.column_settings.poll": "मतदानस्य परिणामः :",
  "notifications.column_settings.push": "आघातविज्ञापनानि",
  "notifications.column_settings.reblog": "बुस्तः :",
  "notifications.column_settings.show": "स्तम्भे दर्शय",
  "notifications.column_settings.sound": "ध्वनिं वादय",
  "notifications.column_settings.status": "नूतनपत्राणि:",
  "notifications.column_settings.unread_notifications.category": "अपठितविज्ञापनानि",
  "notifications.column_settings.unread_notifications.highlight": "अपठितविज्ञापनानि उद्वर्णय",
  "notifications.column_settings.update": "सम्पादनानि :",
  "notifications.filter.all": "सर्वम्",
  "notifications.filter.boosts": "बुस्तः",
  "notifications.filter.follows": "अनुसरति",
  "notifications.filter.mentions": "उल्लिखितानि",
  "notifications.filter.polls": "मतदानस्य परिणामः",
  "notifications.filter.statuses": "त्वयानुसरितजनेभ्यः परिवर्तनानि",
  "notifications.grant_permission": "अनुमतिं देहि।",
  "notifications.group": "{count} विज्ञापनानि",
  "notifications.mark_as_read": "सर्वाणि विज्ञापनानि पठितरूपेण चिह्नीकुरु",
  "notifications.permission_denied": "पूर्वस्यास्वीकृतब्रौसरनुमत्यनुरोधस्य कारणाद्देस्क्तप्विज्ञापनानि न उपलब्धानि",
  "notifications.permission_denied_alert": "देस्क्तप्विज्ञापनानि सकर्तुं न शक्यते यतो ब्रौसरनुमतिं पूर्वेऽस्वीकृतम्",
  "notifications.permission_required": "देस्क्तप्विज्ञापनानि नोपलब्धानि यतोहि आवश्यकानुमतिं न स्वीकृतम्।",
  "notifications_permission_banner.enable": "देस्क्टप्विज्ञापनानि सशक्तं कुरु",
  "notifications_permission_banner.how_to_control": "यदा माटोडोन्नोद्घाटितस्तदा विज्ञापनानि प्राप्तुं देस्क्तप्विज्ञापनानि सशक्तं कुरु। यदा तानि सशक्तानि तदा {icon} गण्डस्य माध्यमेन केऽपि प्रकारास्संवादा देस्क्तप्विज्ञापनानि जनयन्तीति नियामकं कर्तुं शक्नोषि।",
  "notifications_permission_banner.title": "मा कदापि वस्तु त्यज",
  "onboarding.follows.empty": "दुर्भाग्यतया इदानीं कोऽपि परिणामो न दृश्यते। अन्वेषणमुपयोजयितुं वा जनमनुसर्तुं गवेषणपृष्ठस्यान्वेषणं यतितुं शक्नोषि वा पश्चात्पुनर्यतस्व।",
  "picture_in_picture.restore": "तत्प्रतिस्थापय",
  "poll.closed": "बद्धम्",
  "poll.refresh": "नवीकुरु",
  "poll.total_people": "{count, plural, one {# जनः} other {# जनाः}}",
  "poll.total_votes": "{count, plural, one {# मतम्} other {# मतानि}}",
  "poll.vote": "मतम्",
  "poll.voted": "एतदुत्तरं मतमदाः",
  "poll.votes": "{votes, plural, one {# मतम्} other {# मतानि}}",
  "poll_button.add_poll": "निर्वाचनं योजय",
  "poll_button.remove_poll": "निर्वाचनं मार्जय",
  "privacy.change": "पत्रस्य गोपनीयतां परिवर्तय",
  "privacy.public.short": "सार्वजनिकम्",
  "privacy_policy.last_updated": "अन्तिमवारं परिवर्तितम् {date}",
  "privacy_policy.title": "गोपनीयतानीतिः",
  "refresh": "नवीकुरु",
  "relative_time.days": "{number}दि",
  "relative_time.full.days": "{number, plural, one {# दिनं} other {# दिनानि}} पूर्वम्",
  "relative_time.full.hours": "{number, plural, one {# होरा} other {# होराः}} पूर्वम्",
  "relative_time.full.just_now": "अधुनैव",
  "relative_time.full.minutes": "{number, plural, one {# क्षणं} other {# क्षणानि}} पूर्वम्",
  "relative_time.full.seconds": "{number, plural, one {# पलं} other {# पलानि}} पूर्वम्",
  "relative_time.hours": "{number}हो",
  "relative_time.just_now": "अधुना",
  "relative_time.minutes": "{number}क्ष",
  "relative_time.seconds": "{number}प",
  "relative_time.today": "अद्य",
  "reply_indicator.cancel": "नश्यताम्",
  "report.block": "निषेधः",
  "report.block_explanation": "तेषां पत्राणि न द्रक्ष्यसि। ते तव पत्राणि द्रष्टुमुत त्वामनुसर्तुं न शक्नुवन्ति। ते अवरुद्धाः इति ते वक्तुं शक्नुवन्ति।",
  "report.categories.other": "अन्य",
  "report.categories.spam": "फल्गुसन्देशाः",
  "report.categories.violation": "पूरकः एकं वा एकाधिकान्सर्वरो नियमानुल्लङ्घयति",
  "report.category.subtitle": "उत्तमं मेलनं चिनु",
  "report.category.title": "अनेन {type} इत्यनेन किम्भवतीति ब्रूहि नः",
  "report.category.title_account": "प्रोफैल्",
  "report.category.title_status": "पत्रम्",
  "report.close": "कृतम्",
  "report.comment.title": "अन्य किमपि नो ज्ञापयितुमिच्छसि वा?",
  "report.forward": "{target} प्रत्यग्रे प्रेषय",
  "report.forward_hint": "एकौण्टयमन्यसर्वर्तः। अनामिकप्रतिलिमावेदनस्य तत्रापि प्रेषयितुमिच्छसि वा?",
  "report.mute": "मूकीकुरु",
  "report.mute_explanation": "तेषां पत्राणि न द्रक्ष्यसि। तेऽधुनापि त्वामनुसृत्य तव पत्राणि द्रष्टुं शक्नुवन्ति किन्तु ते त्वया मूकीकृता इति ते न वेदिष्यन्ति।",
  "report.next": "परम्",
  "report.placeholder": "Type or paste additional comments",
  "report.reasons.dislike": "एतन्न मे रोचते",
  "report.reasons.dislike_description": "एतन्न किञ्चित्त्वं द्रष्टुमिच्छसि",
  "report.reasons.other": "एतत्किञ्चिदन्य एव",
  "report.reasons.other_description": "समस्या अन्यवर्गेषु नोपज्यते",
  "report.reasons.spam": "फल्गुसन्देशोऽयम्",
  "report.reasons.spam_description": "हिंसापरायणास्सन्धयः, असत्याभ्युपगमो वा पुनरावर्तनीयानि उत्तराणि",
  "report.reasons.violation": "एतत्सर्वरो नियमानुलङ्घयति",
  "report.reasons.violation_description": "एतद्विशेषनियमामुलङ्घयतीति वेत्सि",
  "report.rules.subtitle": "यानि प्रयोजयन्ति तानि चिनु",
  "report.rules.title": "केषां नियमानामुल्लङ्घनं क्रियते?",
  "report.statuses.subtitle": "यानि प्रयोजयन्ति तानि चिनु",
  "report.statuses.title": "कानि पत्राणि सन्ति वा यानि आवेदनमिदं समर्थयन्ति?",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report.thanks.take_action": "इमे इह तव विकल्पास्सन्ति मास्टोडोनि यत्पश्यसि तद्यन्त्रयितुम् :",
  "report.thanks.take_action_actionable": "एतस्य अस्माभिरवलोकनस्य समये @{name} इत्यस्योपरि अभियोगयितुं शक्नोषि :",
  "report.thanks.title": "इदं द्रष्टुं नेच्छसि वा?",
  "report.thanks.title_actionable": "अवेदनाय धन्यवादः, वयं एतदवलोकयिष्यामि।",
  "report.unfollow": "@{name} विसर",
  "report.unfollow_explanation": "समयोऽयमनुसरसि। तव गृहनिरासे तस्य पत्राणि न द्रष्टुं तं विसर।",
  "report_notification.attached_statuses": "{count, plural, one {{count} पत्रं} other {{count} पत्राणि}} संयुज्यते/संयुज्यन्ते",
  "report_notification.categories.other": "अन्य",
  "report_notification.categories.spam": "फल्गुसन्देशाः",
  "report_notification.categories.violation": "नियमोल्लङ्घनम्",
  "report_notification.open": "आवेदनमुद्धाटय",
  "search.placeholder": "अन्विच्छ",
  "search.search_or_paste": "URL अन्विच्छ वा लेपनं कुरु",
  "search_results.all": "सर्वम्",
  "search_results.hashtags": "प्रचलितवस्तूनि",
  "search_results.statuses": "पत्राणि",
  "server_banner.about_active_users": "विगतेषु ३० दिनेषु सर्वरमिममुपयुज्यमाणा जनाः (मासिकसक्रियोपभोक्तारः)",
  "server_banner.active_users": "सक्रियोपभोक्तारः",
  "server_banner.administered_by": "इत्यनेन अधिकृतः : ",
  "server_banner.server_stats": "सर्वरः स्थितिविषयकानि :",
  "sign_in_banner.create_account": "समयं संसृज",
  "sign_in_banner.sign_in": "सम्प्रवेशं कुरु",
  "status.admin_account": "@{name} कृते अनतिक्रममध्यस्थमुद्धाटय",
  "status.admin_domain": "{domain} कृते अनतिक्रममध्यस्थमुद्धाटय",
  "status.admin_status": "पत्रमिदमुद्घाटय अनतिक्रममध्यस्थे",
  "status.block": "अवरुध्यताम् @{name}",
  "status.bookmark": "पुटचिह्नीकुरु",
  "status.cancel_reblog_private": "विबुस्तं कुरु",
  "status.cannot_reblog": "पत्रमिदं बुस्तं कर्तुं न शक्यते",
  "status.copy": "सञ्चयं पत्रे प्रतिलिपिं कुरु",
  "status.delete": "मार्जय",
  "status.detailed_status": "विस्तृतसंभाषणदृश्यम्",
  "status.edit": "सम्पादय",
  "status.edited_x_times": "Edited {count, plural, one {{count} वारम्} other {{count} वारम्}}",
  "status.filter": "पत्रमिदं फिल्तरं कुरु",
  "status.history.created": "{name} असृजत् {date}",
  "status.history.edited": "{name} समपादयत् {date}",
  "status.load_more": "अधिकं स्थापय",
  "status.media_hidden": "प्रसारमाध्यमानि प्रच्छादितानि",
  "status.mention": "उल्लिख्यताम् @{name}",
  "status.more": "अधिकम्",
  "status.mute": "निःशब्दम् @{name}",
  "status.mute_conversation": "वार्तालापं मूकीकुरु",
  "status.open": "पत्रमिदं विस्तारय",
  "status.pin": "प्रोफैलि कीलीकुरु",
  "status.read_more": "अधिकं पठ्यताम्",
  "status.reblog": "बुस्त्",
  "status.reblogs.empty": "न केनापि पत्रमिदं बुस्त्कृतम्। यदा कोऽपि करोति, तानि इह दृश्यन्ते।",
  "status.redraft": "मार्जय पुनश्च लिख्यताम्",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
